import React, { Component } from "react";
import { FadeLoader } from "react-spinners";

import { Container, Body } from "./styles";

class Loading extends Component {
  render() {
    return (
      <Container>
        <Body>
          <FadeLoader color={"#074F8C"} />
        </Body>
      </Container>
    );
  }
}
export default Loading;
